/* 빌드 타임 설정. Vite 는 VITE_ 로 시작하는 환경변수만 브라우저로 넘긴다.
   값은 저장소 루트 .env 에 둔다 (.env.example 참고) — vite.config.js 의 envDir 이
   거기를 가리킨다. 접두사 없는 값(KAKAO_REST_KEY 등)은 같은 파일에 있어도 안 나간다. */

const env = import.meta.env;

export const KAKAO_JS_KEY = env.VITE_KAKAO_JS_KEY || "";

/** "37.5006,127.0365" → [37.5006, 127.0365]. 비어 있으면 null. */
export const ORIGIN = (() => {
  const raw = (env.VITE_ORIGIN || "").trim();
  if (!raw) return null;
  const parts = raw.split(",").map((n) => Number(n.trim()));
  return parts.length === 2 && parts.every(Number.isFinite) ? parts : null;
})();

export const REDUCED_MOTION = matchMedia("(prefers-reduced-motion: reduce)").matches;
